import { render } from "./AddTransfertMpostBox.vue?vue&type=template&id=23b67254&ts=true"
import script from "./AddTransfertMpostBox.vue?vue&type=script&lang=ts"
export * from "./AddTransfertMpostBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__